import { RestApiState } from "../../interfaces/Rest/types";
import { Text } from "../units/Text"
import { useEffect } from "react";



interface SubmitButtonProps {
    restState: RestApiState;
    disabled: boolean;
    text?: string;
    borderRadius?: '5px' | '10px' | '15px'
    restHandler: {
        timeOutId: NodeJS.Timeout | null;
        setter: (key: 'timeOutId' | 'requestState', value: any) => void;
    }
    height?: string;
    width?: string;
    className?:string;
    p?: 'p4' | 'p3' | 'p2' | 'p1' | 'p0' | 'p-v-0' | 'p-v-1' | 'p-v-2' | 'p-v-3' | 'p-v-4';
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}


export const SubmitButton = ({
    restState, 
    disabled, 
    text='Отправить', 
    borderRadius='5px', 
    restHandler, 
    width="100%", 
    className="",
    p="p2",
    ...props
}:SubmitButtonProps) => {
    const cls = `${className} ${p} standard-border`
    const statusCls = `slide-bottom-to-top ${p}`

    useEffect(() => {
        // Effect that handles the state of a btn based pn RestApiState
        async function timeoutHandler() {
            if (restState !== RestApiState.Idle) {
                restHandler.setter('requestState', RestApiState.Idle);
            }
        }

        if (restHandler.timeOutId !== null) {
            clearTimeout(restHandler.timeOutId)
        }

        if (restState !== RestApiState.Pending && restState !== RestApiState.Idle) {
            let timeOut = setTimeout(timeoutHandler, 1500);
            restHandler.setter('timeOutId', timeOut);
        }
            
    }, [restState])
    
    function btnStyleHandler(status: RestApiState): string {
        // Defines css class based on status

        if (status === RestApiState.Success) {
            return "submit-btn-success text-light"
        }
    
        if (status !== RestApiState.Idle)  {
            return 'submit-btn disabled'
        }

        if (disabled) {
            return 'submit-btn disabled'
        }
    
        return "bg-secondary text-light"
    }

    const statusText = ():string => {
        let text = ''
        switch(restState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Готово"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            case RestApiState.Restricted: text="Нету доступа"; break;
            default: text = "..."; break;
        }
        return text
    }

    return (
        <button 
            onClick = {props.onClick}
            type="submit"
            disabled={ ( restState !== RestApiState.Idle ) && ( disabled ) }
            className={ btnStyleHandler(restState) + ' ' + cls }
            style={{position:'relative', height: props.height, width: width, borderRadius: borderRadius, outline:'none', border: 'none', cursor:"pointer", transition: "0.15s ease-in"}}
        >
            { restState === RestApiState.Idle && <Text className="slide-bottom-to-top">{text}</Text>  }
            { restState === RestApiState.Pending && ( 
                <Text className={`slide-bottom-to-top`}> {" "}  { <div className="btnloader"></div> }</Text>
            )}
            { (restState !== RestApiState.Pending && restState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>}
            { restState=== RestApiState.ServerError && <Text className="slide-bottom-to-top"> Ошибка сервера </Text>}
        </button>
    )
}